import { Log } from './log';
import { LogType } from './log-type';
import { LogDisplayMode } from './log-display-mode';

export class Logger {
  public static displayMode = LogDisplayMode.none;
  public static userContext: any;
  public static token: string;
  private static logStack: Log[] = [];

  public static v(...o: any) {
    const l = new Log(o, LogType.verbose);
    this.logStack.push(l);
    this.print(l);
  }

  public static e(...o: any) {
    const l = new Log(o, LogType.error);
    this.logStack.push(l);
    this.print(l);
  }

  public static s(...o: any) {
    const l = new Log(o, LogType.special);
    this.logStack.push(l);
    this.print(l);
  }

  public static w(...o: any) {
    const l = new Log(o, LogType.warning);
    this.logStack.push(l);
    this.print(l);
  }

  public static printStack() {
    console.log({
      header: this.generateHeader(),
      logs: this.logStack,
    });
    this.logStack = [];
  }

  public static print(l: Log) {
    switch (this.displayMode) {
      case LogDisplayMode.console:
        l.console();
        break;
      case LogDisplayMode.debug:
        if (l.type === LogType.error || this.logStack.length > 20) {
          this.printStack();
        }
        break;
      case LogDisplayMode.soft:
        if (l.type === LogType.error) {
          this.printStack();
        }
    }
  }

  private static generateHeader() {
    return {
      token: this.token,
      user: this.userContext,
      userAgent: navigator.userAgent,
      href: window.location.toString(),
    };
  }
}
